import MediaFile from 'Flow2/util/MediaFile';

class Clip {
    static parseClip(clip) {

        let preview = null;
        let mainThumb = clip.mainthumbnail !== null ? clip.mainthumbnail.url : null;
        if (mainThumb === null && clip.thumbnails.elements.length > 0) {
            mainThumb = clip.thumbnails.elements[0].url;
        }
        //temp fix for mainthumb
        //mainThumb = clip.thumbnails.elements.length > 0 ? clip.thumbnails.elements[0].url : null;

        let mediafiles = clip.mediafiles.elements ? clip.mediafiles.elements : [];
        mediafiles.forEach(mf => {
            if (mf.tags && mf.tags.split(',').indexOf('preview') !== -1) {
                preview = mf;
            }
        })
        if (preview === null) {
            if (clip.mediafiles.elements[0]) {
                preview = clip.mediafiles.elements[0];
            }
        }
        let mediaTypes = [];
        mediaTypes = Object.keys(clip.media.fields);
        // clip.addEventListener("update", (e) => {console.log('updated')});
        return {
            id: clip.metadata.fields.id || clip.metadata.fields.clipid || clip.id,
            title: clip.metadata.titel_de,
            status: clip.status,
            mainthumbnail: mainThumb,
            metadata: clip.metadata.fields,
            mainmediafile: preview,
            mediafiles: clip.mediafiles.elements,
            thumbnails: clip.thumbnails.elements,
            media: mediaTypes,
            mediaType: MediaFile.getMediaType(mediaTypes),
            originalObject: clip,
        };
    }

    static isSelectedInRoom(clip, clId) {
        let ret = false;
        if(clip.metadata.specifics) {
            try {
                let specifics = JSON.parse(clip.metadata.specifics);
                if(specifics.customtags && specifics.customtags[clId]) {
                    Object.keys(specifics.customtags[clId]).forEach(key => {
                        if(specifics.customtags[clId][key].indexOf('newsroompublish') > -1) {
                            ret = true;
                        }
                    });
                }
            } catch (e) {
                console.log(e);
            }
        }
        return ret;
    }

    static getImportStatus(importstatus) {
        const states = ["importing", "processing", "exporting"];
        importstatus = importstatus || "";

        for (let state of states) {
            if (importstatus.indexOf(state) !== -1) {
                return state;
            }
        }

        return "";
    }

    static getDownloadList(clip) {
        const list = [];
        if (clip && clip.mediafiles) {
            clip.mediafiles.forEach((file, index) => {
                list.push({ ...file, information: MediaFile.getInformation(file) });
            });

            list.sort(function (a, b) {
                if (a.information < b.information) { return -1; }
                if (a.information > b.information) { return 1; }
                return 0;
            });
        }

        return list;
    }

    static getLocalAndRemoteIds(props, clips = []) {
        const ids = {
            localIds: [],
            remoteIds: {}
        };
        
        clips.forEach(dropClip => {
            for(let clip in props.clips) {
                if(props.clips[clip].id === dropClip) {
                    let device = props.clips[clip].originalObject.remoteserverdevice;
                    
                    if(device) {
                        if(!ids.remoteIds.hasOwnProperty(device)) {
                            ids.remoteIds[device] = [dropClip];
                        } else {
                            ids.remoteIds[device].push(dropClip);
                        }
                    } else {
                        ids.localIds.push(dropClip);
                    }
                    
                    break;
                }
            }
        });
        
        return ids;
    }
}

export default Clip;
